import { useSearchParams } from 'react-router';

export type ResetAllQueryParameters = () => void;

const useResetAllQueryParameters = (): ResetAllQueryParameters => {
  const [searchParameters, setSearchParameters] = useSearchParams();

  const resetAllQueryParameters = (): void => {
    // The selected table view is presentation state, not a filter.
    setSearchParameters(searchParameters.get('view') === 'operational' ? { view: 'operational' } : {});
  };

  return resetAllQueryParameters;
};

export default useResetAllQueryParameters;
